import React, { useState } from 'react'
import moment from 'moment'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
//@MUI
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'
import BreathSounds from './BreathSounds'
import Cough from './Cough'
import Cyanosis from './Cyanosis'
import AssessmentText from '../AssessmentText'

const Respiratory = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Stack gap={2} padding={1} component={Paper}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Respiratory Assessment</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <BreathSounds moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Cough moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Cyanosis moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <AssessmentText moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Grid item xs={12}>
          <Button onClick={() => submitModule('Respiratory', moduleValues)} variant="contained" color="success" fullWidth>
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default Respiratory
